import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Sports win commission — owner-only. The server refuses staff/executive
// sessions via requireOwner; the sidebar and OWNER_ONLY_ROUTES hide the screen
// on the client.
// Plan: docs/plans/2026-09-12-commission-market-league-split.md
const commissionConfigService = {
  // {
  //   markets: [{ key, label, group, hint }],
  //   default_league_key: 'default', max_percent, default_percent,
  //   sports: [{ sport_id, name, enabled, active_count, leagues: [
  //     { key, label, is_default, active_count,
  //       rules: { matchodds: { state: 'on'|'off'|'inherit', percent, inherited } } }
  //   ]}]
  // }
  getSportsCommission: async () => {
    const response = await api.get(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS)
    return response.data
  },
  // { sport_id, league_key, market_key, enabled, percent }
  saveSportsCommission: async (payload) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, payload)
    return response.data
  },
  // { items: [{ sport_id, league_key, market_key, enabled, percent }, …] }
  // One request for every dirty cell — the grid gained a league dimension, so
  // saving cell by cell meant dozens of round trips.
  saveSportsCommissionBulk: async (items) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS_BULK, { items })
    return response.data
  },
  // { sport_id, league_key, market_key } — drops a league override so the cell
  // inherits the sport's default row again. Never valid on the default league.
  resetSportsCommission: async (payload) => {
    const response = await api.delete(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, { data: payload })
    return response.data
  },
}

export default commissionConfigService
